<template>
  <section class="nav-wrap" :style="navStyle">
    <el-progress :percentage="percentage" :show-text="false" :stroke-width="2" color="#FF842E"
                 v-if="percentage!==100 && this.$route.path!=='/login' && this.$route.path!=='/regist' && this.$route.path!=='/resetPass'"></el-progress>
    <div style="display: grid; grid-template-columns: 270px auto 150px; align-items: center; width: 80vw; max-width: 1440px; margin: 0 auto; gap: 20px" :style="!(percentage!==100 && this.$route.path!=='/login' && this.$route.path!=='/regist' && this.$route.path!=='/resetPass') ? {marginTop: '2px'} : {}">
      <img src="/img/logo/hr-logo3.png" style="width: 270px"/>
      <el-menu style="" ref="menu" :default-active="activeId" text-color="#444444" active-text-color="#FF8632"
               :router="false" class="el-menu-demo" mode="horizontal">
        <el-menu-item style="padding: 0" v-for="item in navList" :key="item.index" :index="item.index"
                      @click.native="urlChange(item.url)">
          {{ item.title }}
        </el-menu-item>
      </el-menu>
      <div class="login-item" style="text-align: right">
        <div style="height: 74px; align-content: center" v-if="!isLogin">
          <!-- <el-button style="width: 100px; height: 40px;" size="mini" type="border" class="login-btn login" @click="showLogin">登录</el-button> -->
          <!-- <el-button style="width: 100px; height: 40px;" size="mini" type="warning" class="login-btn regist" @click="showRegist">注册</el-button> -->
          <el-button style="width: 100px; height: 35px;" size="mini" type="warning" class="login-btn regist"
                     @click="showLogin">登录&nbsp;|&nbsp;注册
          </el-button>
        </div>
        <div class="login-user" style="display: flex; align-items: center; gap: 20px" v-else>
          <div class="notice" @click.stop="showNotice=!showNotice">
            <!-- <i class="iconfont icon-ziyuan"></i> -->
            <el-badge is-dot :hidden="dataList.length == 0 ? true : false" style="margin-left: auto">
              <i class="iconfont icon-ziyuan"></i>
            </el-badge>
            <div class="notice-container" :style="{'display': showNotice?'block':'none'}">
              <div class="title" style="font-weight: 800;">访问申请</div>
              <div class="applyList">
                <div class="apply-item" v-for="item in dataList">
                  <span>{{ item.nickname }}申请访问您的案例<span style="font-weight: 800;"> {{ item.caseName }}</span></span>
                  <span class="btn">
								<el-button type="text" @click.stop="handle(item.id)">处理</el-button>
							</span>
                </div>
                <el-empty v-if="dataList.length == 0" :image-size="150"></el-empty>
              </div>
            </div>
          </div>
          <el-dropdown @command="handleCommand">
            <el-image class="headicon" :src="data.avatar" fit="fill">
              <div slot="error" class="image-slot">
                <el-image class="headUrl" :src="data.avatar" fit="fill">
                	<div slot="error" class="image-slot">
                	  <el-image class="headUrl" :src="require('@/assets/header.png')" fit="fill"></el-image>
                	</div>
                </el-image>
              </div>
            </el-image>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">个人主页</el-dropdown-item>
              <el-dropdown-item command="b">福利中心</el-dropdown-item>
              <el-dropdown-item command="c">个人设置</el-dropdown-item>
              <el-dropdown-item command="d">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-dialog title="申请处理" width="340px" :visible.sync="dialogVisible" :append-to-body="true">
          <el-form :inline="false" label-position="right" label-width="90px" :model="result" ref="form" :rules="rules">
            <el-form-item prop="passed" label="处理结果:" required>
              <el-select v-model="result.passed" placeholder="请选择处理结果">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="date" label="过期时间:">
              <el-date-picker v-model="result.date" type="date" :picker-options="picker" value-format="yyyy-MM-dd"
                              placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="handleApply">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from '@/utils/eventHub.js'
import {getIsTrial, getToken, removeToken} from '@/utils/auth'
import {getSelfInfo, updateUser} from '@/api/personal/index'
import {applyHandle, getApplyList} from '@/api/crowd/index'

var index;
export default {
  data() {
    var validateFun = (rule, value, callback) => {
      if (value == '' && this.result.passed == 1) {
        callback(new Error('请选择过期时间!'));
      } else {
        callback()
      }
    }
    return {
      activeId: '5',
      isLogin: false,
      percentage: 0,
      dataList: [],
      showNotice: false,
      headurl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      navList: [{
        index: '0',
        title: '首页',
        url: '/'
      }, {
        index: '1',
        title: '软件商店',
        url: '/store'
      }, {
        index: '2',
        title: '快速开发平台',
        url: '/platform'
      }, {
        index: '3',
        title: '众包平台',
        url: '/crowd'
      }, {
        index: '4',
        title: '社区',
        url: '/social'
      }, {
        index: '5',
        title: '案例库',
        url: '/case'
      }],
      navStyle: {
        'background-color': 'uset'
      },
      data: {},
      result: {
        id: '',
        date: '',
        passed: ''
      },
      options: [{
        value: 1,
        label: '通过'

      }, {
        value: 2,
        label: '拒绝'
      }],
      picker: {
        disabledDate(time) {
          // 禁用今天之前的日期
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        passed: [
          {required: true, message: '请选择处理结果', trigger: 'change'}
        ],
        date: [
          {type: 'date', validator: validateFun, trigger: 'change'}
        ],
      },
      dialogVisible: false
    }
  },
  methods: {
    async getInfo() {
      const res = await getSelfInfo()
      if (res.code === 0) {
        this.data = res.data
		this.$forceUpdate()
        localStorage.setItem('user', JSON.stringify(res.data))
        EventBus.$emit('getPoints', res.data.integral)
      } else {
        this.$message.error(res.msg)
      }
    },
    urlChange(url) {
      clearInterval(index);
      this.percentage = 0
      this.getpercentage()
      if (url) {
        this.$router.push(url)
      } else {
        this.$message.error('网站正在建设中,请耐心等待');
      }
    },
    showLogin() {
      // this.$emit('showLogin',1)
      this.$router.push('/login')
    },
    showRegist() {
      this.$router.push('/regist')
    },
    handleScroll() {
      if (window.scrollY > 0) {
        this.navStyle['background-color'] = '#fff'
      } else {
        this.navStyle['background-color'] = 'unset'
      }
    },
    handleCommand(command) {
      this.activeId = ''
      if (command == 'c') {
        this.$router.push({path: '/personal/profile'})
      } else if (command == 'b') {
        this.$router.push({path: '/personal/welfare/signin'})
      } else if (command == 'd') {
        removeToken()
        EventBus.$emit('isLogin', false)
        if (this.$route.path.indexOf('personal') !== -1) {
          this.$router.push('/login')
        }
      } else {
        this.$router.push({path: '/personal/homepage/topic'})
      }
    },
    getpercentage() {
      index = setInterval(() => {
        this.percentage += 10;
      }, 100)
    },
    async getAnliApply() {
      const res = await getApplyList({page: 1, limit: 10, isPass: 0})
      if (res.code === 0) {
        this.dataList = res.data.list
      } else {
        this.$message.error(res.msg)
      }
    },

    handleApply() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.dialogVisible = false
          const res = await applyHandle({
            id: this.result.id,
            expirationDate: this.result.date + ' 23:59:59',
            isPass: this.result.passed
          })
          if (res.code === 0) {
            this.$message.success('处理成功')
          } else {
            this.$message.error(res.msg)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handle(id) {
      this.result.id = id
      this.dialogVisible = true
      this.showNotice = false
    }
  },
  mounted() {
    this.$nextTick(() => {
	  this.data = JSON.parse(localStorage.getItem('user')) 
      for (var i = 0; i < this.navList.length; i++) {
        if (this.$route.path.indexOf(this.navList[i].url) !== -1 && this.navList[i].url !== '/') {
          this.activeId = this.navList[i].index
          return
        } else {
          this.activeId = ""
        }
      }
      if (this.$route.path == '/') {
        this.activeId = '0'
      }
    })
    if (getToken()) this.isLogin = true;
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'notice-container') {
        this.showNotice = false
      }
    })
    window.addEventListener('scroll', this.handleScroll);
    EventBus.$on('isLogin', (result) => {
      this.isLogin = result
      if (result) {
        this.$router.go(-1)
        this.getInfo()
		this.getAnliApply()
      }
    })
    this.getpercentage()
	window.addEventListener('beforeunload', ()=>{
		if(this.isLogin){
			this.getAnliApply()
		}
	}); 
    EventBus.$on('loadFinished', (result) => {
      if (result) {
        this.percentage = 100
      }
    })
    EventBus.$on('jifenChange', (result) => {
      if (result) {
        this.getInfo()
      }
    })
  },
  watch: {
    percentage(newval) {
      if (newval == 90) {
        clearInterval(index);
      }
      if (newval == 100) {
        clearInterval(index);
      }
    },
    '$route': {
      handler: function (to, from) {
        // 根据当前的路由路径设置激活项
        window.scrollTo({top: 0})
        for (var i = 0; i < this.navList.length; i++) {
          if (this.$route.path.indexOf(this.navList[i].url) !== -1 && this.navList[i].url !== '/') {
            this.activeId = this.navList[i].index
            return
          } else {
            this.activeId = ""
          }
        }
        if (this.$route.path == '/') {
          this.activeId = '0'
        }
      },
      immediate: true
    }
  },
  destroyed() {
    EventBus.$off('isLogin')
    clearInterval(index);
  },

}
</script>

<style lang="scss" scoped>
.nav-wrap {
  width: 100%;
  // height: 62px;
  // background: #fff;
  color: #444444;
  text-align: center;
  position: fixed;
  top: 0;
  z-index: 999;

  .el-menu {
    width: fit-content;
    padding: 20px;
    display: flex;
    text-align: center;
    align-items: center;
    display: inline-block;
    background-color: unset;

    &.el-menu--horizontal {
      border: none;
    }

    /deep/ .el-menu-item {
      //width: 116px;
      height: 34px;
      line-height: 34px;
      padding: 0 20px !important;
      font-size: 18px;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
    /deep/ .el-menu-item {
      transition: background-color .3s,color .3s;
    }
    /deep/ .el-menu-item.is-active {
      background-color: #F6F1EE;
      border-radius: 34px;
      border-bottom: none;

      &:hover {
        background-color: #F6F1EE;
      }
    }

    /deep/ .el-menu-item:hover {
      color: #FF8632 !important;
      background-color: unset;
    }

    /deep/ .el-menu--popup {
      min-width: fit-content;
    }

    .el-submenu /deep/ .el-menu-item {
      min-width: fit-content;
    }
  }

  .login-item {
    float: right;
    //margin-right: 13vw;
    //margin-top: 18px;
    .login-btn {
      font-size: 14px;
      margin-top: 3px;

      &.login {
        background-color: #FFFFFF;
        padding: 7px;
        width: 48px;
        height: 30px;
        border-radius: 5px;
        border-radius: 8px;
      }

      &.login:hover {
        color: #FF842E;
        border-color: #FF842E;;
      }

      &.login:active {
        color: #FF842E;
        border-color: #FF842E;;
      }

      &.login:focus {
        color: #FF842E;
        border-color: #FF842E;;
      }

      &.regist {
        background-color: #FF842E;
        padding: 7px;
        width: 48px;
        height: 30px;
        border-radius: 5px;
        border-radius: 8px;
      }

    }

    .headicon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }

    .notice {
      display: inline-block;
      //margin-right: 30px;
      //margin-top: 10px;
      //float: left;
      position: relative;

      .iconfont {
        font-size: 20px;
      }

      .notice-container {
        position: absolute;
        top: 40px;
        left: -140px;
        width: 280px;
        height: 300px;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .05);
        background-color: #fff;
        overflow-y: scroll;
        text-align: left;

        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: silver;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-track {
          background-color: #f1f1f1;
        }

        .apply-item {
          padding: 8px 0;
          border-bottom: 1px solid #D9D8D9;
          font-size: 15px;

          .btn {
            float: right;

            .el-button {
              padding: 0;
            }
          }
        }
      }
    }
  }

}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fdffe2;
  color: #FF842E;
}

@media (min-width: 1025px) and (max-width: 1110px) {
  .nav-wrap {
    .el-menu {
      padding: 20px 10px;

      /deep/ .el-menu-item {
        min-width: 108px;
        width: fit-content;
      }
    }

    .login-item {
      float: right;
      margin-right: 12vw;
      margin-top: 18px;

    }
  }
}

/* 针对平板的样式 */
@media (min-width: 768px) and (max-width: 1024px) {
  .nav-wrap {
    .el-menu {
      padding: 20px 10px;

      /deep/ .el-menu-item {
        min-width: 88px;
        width: fit-content;
      }
    }

    .login-item {
      float: right;
      margin-right: 2vw;
      margin-top: 18px;

    }
  }
}


</style>
